// src/api/promoterApi.js

import apiClient from './apiClient'; // подключаем HTTP-клиент

// Создаём экземпляр клиента.
// Пустая строка '' означает базовый URL (он уже настроен внутри apiClient)
const promoterClient = apiClient('');

// Объект с методами для работы с промоутерами
const promoterApi = {
    /**
     * Синхронизирует метаданные промоутера из Telegram
     * @param {string} link — ссылка на промоутера в Telegram
     * @returns {Promise<object>} — данные ответа сервера
     */
    syncTelegramMeta: async (link) => {
        const response = await promoterClient.get('/promos/sync-meta', {
            params: { link },
        });
        return response.data;
    },
};

export default promoterApi;
